module.exports = __webpack_public_path__ + "img/Background5.6e1e0fbe.png";